import React, {useEffect, useState} from "react";
import {verifyUserAbilities} from "../../../config/functions";
import {Breadcrumbs, CircularProgress, Grid, Typography} from "@mui/material";
import LinkNavegacao from "../../../common/Link";
import HomeIcon from "@mui/icons-material/Home";
import PageTitle from "../../../common/PageTitle";
import {BlueprintIcon, ProtectiveGearAIcon} from "../../../common/Icons";
import CardOption from "../../../common/CardOption";

export default function SystemManagement() {
    const [abilities, setAbilities] = useState({});
    const [loading, setLoading] = useState(true);

    const permissoesNecessarias = [
        { rota: "contratos/suporteSempher", title: "Painel de Monitoramento", description: "Monitore as empresas e acompanhe o status de suas Máquinas e Equipamentos", url: "painel" },
        { rota: "sistemas", title: "Gerenciamento de Sistemas", description: "Cadastre e gerencie os sistemas oferecidos", url: "sistemas" },
        { rota: "alteracoes", title: "Gerenciamento de Alterações dos Sistemas", description: "Cadastre e gerencie as alterações produzidas pelos sistemas oferecidos", url: "alteracoes" },
        {rota: "tutoriais", title: "Gerenciamento de Tutoriais", description: "Cadastre e acesse guias práticos sobre o uso das ferramentas do sistema", url: "tutoriais"},
    ];

    useEffect(() => {
        const carregarPermissoes = async () => {
            const resultados = {};

            for (const item of permissoesNecessarias) {
                resultados[item.rota] = await verifyUserAbilities({ rota: item.rota });
            }

            setAbilities(resultados);
            setLoading(false);
        };

        carregarPermissoes();
    }, []);

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
    <>
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={3}
        >
            <Grid item xs={12}>
                <Breadcrumbs>
                    <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao >
                    <Typography variant='span'>Admin Sempher</Typography>
                    <Typography variant='span'>Gestão Operacional</Typography>
                </Breadcrumbs>
                <PageTitle icon={<BlueprintIcon fontSize='large' />} title='Gestão Operacional' />
                <Typography p>Nesta seção de Gestão Operacional, gerencie os serviços oferecidos pela ASW/Sempher Solutions.</Typography>
            </Grid>

            {permissoesNecessarias.map((item) => {
                const temPermissao = abilities[item.rota]?.data.success;
                return (
                    <Grid
                        key={item.rota}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={3}
                        sx={{
                           opacity: temPermissao ? 1 : 0.5, 
                            pointerEvents: temPermissao ? 'auto' : 'none',
                        }}
                    >
                        <CardOption
                            title={item.title}
                            description={item.description}
                            url={item.url}
                            hasPermisson={temPermissao}
                            sx={{
                                backgroundColor: temPermissao ? 'transparent' : 'gray',
                                color: temPermissao ? 'black' : 'gray',
                            }}
                        />
                    </Grid>
                );
            })}
        </Grid>
    </>);
}